export default {
    exportName: 'AdminConsoleInfo',
    content: () => import('@/Fwamework/Importer/Components/ExcelAdminConsoleComponent.vue'),
    contentData: {
        key: 'ExcelAdminConsole',
        visible: true
    }
};